<div class="w-p-100 h-p-100 flex flex-row flex-1-0-auto">
  <div class="law-changes-widget-container h-p-100 p-t-30 scroll full-grow-no-shrink-no-basis ">
    <particle-shimmer-loader
      [elemCount]="1"
      [elemWidth]="375"
      [elemHeight]="500"
      [elemPadding]="10"
      [elemMargin]="10"
      [isVisible]="!dataLoaded"
    ></particle-shimmer-loader>

    <div *ngIf="(hasData$|async) && dataLoaded" class="m-lr-30 flex flex-col full-grow-no-shrink-no-basis ">
      <div class="blue-box-container m-b-20">
        <span>Note:</span> Displaying law changes published in the last 7 days ({{fromDate | date :'longDate'}}
        to {{toDate
        | date :'longDate'}}).
      </div>

      <mat-accordion class="custom-accordion">
        <div *ngFor="let countryChange of lawChanges" class="accordion-news-conent">
          <h1 class="title">
            {{countryChange.title}}
          </h1>
          <div *ngFor="let topicChange of countryChange.items" class="flex flex-col">
            <h1 class="sub-title flex flex-row flex-wrap justify-between items-start">
              <div>
                {{topicChange.subTitle}}
              </div>
            </h1>
            <div *ngFor="let lawChange of topicChange.items" class="content-container">
              <div [innerHtml]="lawChange.description"></div>

              <div *ngIf="lawChange.effectiveDate" class="itrce-news-links-container flex flex-row">
                <div class="italic">
                  Effective Date:&nbsp;
                </div>
                <div class="italic flex flex-row flex-wrap">
                  {{lawChange.effectiveDate|taxnewsDateFormat}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-accordion>
    </div>
    <div *ngIf="!(hasData$| async) && dataLoaded" class="empty-content flex flex-col flex-1-0-100">
      <div class="text-container">
        <img
          src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/reports-empty.png"
          alt="Empty images">
        <h1>No changes found</h1>
        <div class="text">We couldn't find any changes for your chosen period and settings. Try adjusting the date
          range,
          change types or topic/country selections.
        </div>
      </div>
    </div>
  </div>
  <div class="page-separator"></div>
  <div class="scroll p-t-30 flex flex-col justify-start items-start full-grow-no-shrink-no-basis ">
    <div class="hide-message flex flex-row justify-end items-center">
      <!-- <a href="#">
         Hide this message
       </a>-->
    </div>
    <div class="map-container w-p-100 flex flex-row justify-start items-start full-grow-no-shrink-no-basis ">
      <particle-dashboard-hitmap></particle-dashboard-hitmap>
      <!--<img  src=".http://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/OrbitaxDashboard-maps.png" class="world-map" alt="Word Map">-->
    </div>
  </div>
</div>
